module.exports = __webpack_public_path__ + "img/icon_doctor.822e5784.svg";